import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchMeasurementMasterList = ({commit}) => {

    axios.get('/measurementMaster/index.php', accessTokenInfo.accessTokenInfo())
    .then(res => {            
        if(res.data.status) {
            commit('setMeasurementMasterList', res.data.response)
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitMeasurementMasterData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/measurementMaster/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            dispatch('fetchMeasurementMasterList')
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/measurementMaster/actions.js